<template>
    <div class="mt-10">
        <div class="container">
            <div class="row" v-show="downloading">
                <div class="col-lg-12 text-center py-3">
                    <b-spinner small label="Espere ..."></b-spinner>
                    <span class="p-1">Espere un momento...</span>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12 text-center py-3">
                    <h3 class="font-weight-light">Adquirir candidato</h3>
                    <b-breadcrumb :items="items" class="bg-transparent p-0"></b-breadcrumb>
                </div>
            </div>

            <div class="row" v-if="!downloading">
                <div class="col-lg-8">
                    <CandidateCV :user="matchJob.user" :job_id="job_id" :contacted="matchJob.contacted"/>
                </div>
                <div class="col-lg-4">
                    <ContactCandidate :candidates_to_use="matchJob.member.candidates_to_use"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import CandidateCV from './components/CandidateCV'
import ContactCandidate from './components/ContactCandidate'
export default {
    components:{
        'CandidateCV': CandidateCV,
        'ContactCandidate': ContactCandidate
    },
    data() {
        return {
            downloading: false,
            job_id: null,
            matchJob: {},
            items: [
                {
                    text: "Recomendaciones",
                    href: ''
                },
                {
                    text: "Candidato",
                    active: true
                },
                {
                    text: "",
                    active: true
                }
            ]
        }
    },
    methods:{
        getCandidate(id, job_id){
        this.downloading = true
            this.api.get('candidate/cv?candidate_id=' + id + '&job_id=' + job_id).then(({data}) => {
                this.matchJob =  data
                this.items[2].text = data.user.name
                this.downloading = false
            }).catch(err => {
                this.downloading = false
            })
        }
    },
    created() {
        let id = this.$route.query.candidate_id
        let job_id = this.$route.query.job_id
        if(id == undefined && job_id == undefined){
            this.$router.push('/')
        }else{
            this.getCandidate(id, job_id)
            this.job_id = job_id
            this.items[0].href = '/job/' + this.job_id + '/recomendation'
        }

    },
}
</script>



// WEBPACK FOOTER //
// src/components/#pages/candidates_gold/CandidateCV.vue